"use client";


import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { normalizeSubCategory } from "@/lib/normalizeSubCategory";
import { getCategoryPath, getSubCategoryPath } from "@/lib/productPaths";
import InfiniteProductGrid from "@/components/InfiniteProductGrid";

export default function ProductsGridClient({ products = [] }) {
  const searchParams = useSearchParams();
  const category = searchParams.get("category");          // main category
  const subCategory = searchParams.get("sub-category");   // subcategory
  const searchTerm = searchParams.get("search");          // search text

  const normalizedSearch = searchTerm?.toLowerCase();

  const filteredProducts = products.filter((p) => {
    const matchesCategory = !category || p.category === category;
    const normalizedSub = normalizeSubCategory(p["sub-category"]);
    const matchesSub = !subCategory || normalizedSub === subCategory;
    const matchesSearch =
      !normalizedSearch ||
      p.name?.toLowerCase().includes(normalizedSearch) ||
      (p.description && p.description.toLowerCase().includes(normalizedSearch)) ||
      (Array.isArray(p.aliases) && p.aliases.some(a => String(a).toLowerCase().includes(normalizedSearch)));

    return matchesCategory && matchesSub && matchesSearch;
  });

  return (
    <>
      {/* Breadcrumb */}
      <div className="container mx-auto py-4 text-sm text-gray-500">
        <Link href="/">Home</Link> &gt;{" "}
        {category ? (
          <Link href={getCategoryPath(category)} className="capitalize">
            {category.replace(/-/g, " ")}
          </Link>
        ) : (
          <span className="capitalize">Products</span>
        )}
        {subCategory && category && (
          <>
            {" "} &gt;{" "}
            <Link
              href={getSubCategoryPath(category, subCategory)}
              className="capitalize"
            >
              {subCategory.replace(/-/g, " ")}
            </Link>
          </>
        )}
        {searchTerm && (
          <>
            {" "} &gt;{" "}
            <span className="italic text-gray-600">
              Search: "{searchTerm}"
            </span>
          </>
        )}
      </div>

      {/* Product Grid */}
      {filteredProducts.length === 0 ? (
        <div className="container mx-auto px-4 py-16 text-center text-gray-600">
          No products match your filters. Try updating the category or search term.
        </div>
      ) : (
        <div className="container mx-auto px-4 flex-1">
          <InfiniteProductGrid products={filteredProducts} category={category || ""} />
        </div>
      )}
    </>
  );
}
